/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Free_Pro_Plus_Compare_Table_CnaInputs */

const en_free_pro_plus_compare_table_cna = /** @type {(inputs: Free_Pro_Plus_Compare_Table_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`|  | Free | Pro | Plus |
| --- | --- | --- | --- |
| Focus Timer | ✔️ | ✔️ | ✔️ |
| Duration Statistics | ✔️ | ✔️ | ✔️ |
| Plant together  | ✔️ | ✔️ | ✔️ |
| Deep Focus Mode | ✔️ | ✔️ | ✔️ |
| Custom App Allow List | - | ✔️ | ✔️ |
| Remove Ads | - | ✔️ | ✔️ |
| Focus trend analysis | - | ✔️ | ✔️ |
| Plant real trees* | - | ✔️ | ✔️ |
| Custom Focus Tags | - | ✔️ | ✔️ |
| Auto-start Next Session | - | ✔️ | ✔️ |
| 3x focus coin | - | - | ✔️ |
| Enjoy Plus Exclusive Trees | - | - | ✔️ |
| Early Access to Seasonal New Trees | - | - | ✔️ |
| Enjoy Seasonal Select Crystal Trees | - | - | ✔️ |
| [Time Guard] Block more interruptive apps | - | - | ✔️ |
| [Mindful Space] Enjoy various Soundscape | - | - | ✔️ |

* *The maximum limit for planting real trees is 5.`)
};

const ar_free_pro_plus_compare_table_cna = /** @type {(inputs: Free_Pro_Plus_Compare_Table_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`|  | مجاني | احترافي | بلس |
| --- | --- | --- | --- |
| مؤقت التركيز | ✔️ | ✔️ | ✔️ |
| إحصائيات المدة | ✔️ | ✔️ | ✔️ |
| ازرعوا معًا | ✔️ | ✔️ | ✔️ |
| وضع التركيز العميق | ✔️ | ✔️ | ✔️ |
| تطبيق مخصص قائمة السماح | - | ✔️ | ✔️ |
| إزالة الإعلانات | - | ✔️ | ✔️ |
| تحليل اتجاه التركيز | - | ✔️ | ✔️ |
| ازرع أشجارًا حقيقية* | - | ✔️ | ✔️ |
| علامات التركيز المخصصة | - | ✔️ | ✔️ |
| بدء الجلسة التالية تلقائيًا | - | ✔️ | ✔️ |
| عملة التركيز 3x | - | - | ✔️ |
| نَمِّى أشجار حصرية من بلس | - | - | ✔️ |
| استمتع بأشجار جديدة في كل موسم | - | - | ✔️ |
| استمتع بـ أشجار كريستالية موسمية مختارة | - | - | ✔️ |
| [حارس الوقت] احظر المزيد من التطبيقات المُشتِّتة | - | - | ✔️ |
| [مساحة اليقظة] استمتع بمجموعة متنوعة من منظر صوتي | - | - | ✔️ |

* *الحد الأقصى لزراعة الأشجار الحقيقية هو 5.`)
};

const de_free_pro_plus_compare_table_cna = /** @type {(inputs: Free_Pro_Plus_Compare_Table_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`|  | Kostenlos | Pro | Plus |
| --- | --- | --- | --- |
| Fokus-Timer | ✔️ | ✔️ | ✔️ |
| Dauerstatistik | ✔️ | ✔️ | ✔️ |
| Gemeinsam pflanzen | ✔️ | ✔️ | ✔️ |
| Deep-Focus-Modus | ✔️ | ✔️ | ✔️ |
| Benutzerdefinierte App Liste zulassen | - | ✔️ | ✔️ |
| Anzeigen entfernen | - | ✔️ | ✔️ |
| Schwerpunkt Trendanalyse | - | ✔️ | ✔️ |
| Echte Bäume pflanzen* | - | ✔️ | ✔️ |
| Benutzerdefinierte Fokus-Tags | - | ✔️ | ✔️ |
| Automatischer Start der nächsten Sitzung | - | ✔️ | ✔️ |
| 3x Fokusmünze | - | - | ✔️ |
| Genieße exklusive Plus-Bäume | - | - | ✔️ |
| Versuchen Sie zuerst Neue Bäume der Saison | - | - | ✔️ |
| Genießen Sie Saisonal ausgewählte Kristallbäume | - | - | ✔️ |
| [Zeitwächter] Blockieren Sie mehr unterbrechende Apps | - | - | ✔️ |
| [Achtsamer Raum] Genießen Sie verschiedene Klanglandschaft | - | - | ✔️ |

* *Maximal 5 echte Bäume können gepflanzt werden.`)
};

const es_free_pro_plus_compare_table_cna = /** @type {(inputs: Free_Pro_Plus_Compare_Table_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`|  | Gratis | Pro | Plus |
| --- | --- | --- | --- |
| Temporizador de concentración | ✔️ | ✔️ | ✔️ |
| Estadísticas de duración | ✔️ | ✔️ | ✔️ |
| Plantar juntos | ✔️ | ✔️ | ✔️ |
| Modo de concentración profunda | ✔️ | ✔️ | ✔️ |
| Lista personalizada de apps permitidas | - | ✔️ | ✔️ |
| Elimina los anuncios | - | ✔️ | ✔️ |
| Análisis de tendencias de concentración | - | ✔️ | ✔️ |
| Planta árboles reales* | - | ✔️ | ✔️ |
| Etiquetas de concentración personalizadas | - | ✔️ | ✔️ |
| Inicio automático de la siguiente sesión | - | ✔️ | ✔️ |
| Moneda de concentración x3 | - | - | ✔️ |
| Disfruta de los Árboles exclusivos Plus | - | - | ✔️ |
| Prueba los Nuevos árboles de temporada primero | - | - | ✔️ |
| Disfruta los Árboles de cristal de temporada seleccionados | - | - | ✔️ |
| [Guardián del Tiempo] Bloquea las apps más intrusivas | - | - | ✔️ |
| [Espacio consciente] Disfruta de diversos paisajes sonoros | - | - | ✔️ |

* *El límite máximo para plantar árboles reales es de 5.`)
};

const fr_free_pro_plus_compare_table_cna = /** @type {(inputs: Free_Pro_Plus_Compare_Table_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`|  | Gratuit | Pro | Plus |
| --- | --- | --- | --- |
| Minuteur de concentration | ✔️ | ✔️ | ✔️ |
| Statistiques de durée | ✔️ | ✔️ | ✔️ |
| Planter Ensemble | ✔️ | ✔️ | ✔️ |
| Mode Concentration Profonde | ✔️ | ✔️ | ✔️ |
| Liste des autorisations personnalisée | - | ✔️ | ✔️ |
| Supprimer les publicités | - | ✔️ | ✔️ |
| Analyse des tendances de concentration | - | ✔️ | ✔️ |
| Plantez de véritables arbres* | - | ✔️ | ✔️ |
| Tags personnalisables | - | ✔️ | ✔️ |
| Démarrage automatique de la prochaine session | - | ✔️ | ✔️ |
| Triplez vos pièces obtenues | - | - | ✔️ |
| Profitez des arbres exclusifs Plus | - | - | ✔️ |
| Essayez les Nouveaux arbres saisonniers en premier | - | - | ✔️ |
| Profitez d'Arbres premium de saison | - | - | ✔️ |
| [Gardien du Temps] Bloquer plus d'applications dérangeantes | - | - | ✔️ |
| [Espace de relaxation] Profitez d'une multitude de Paysages sonores | - | - | ✔️ |

* *Vous pouvez planter jusqu’à 5 vrais arbres.`)
};

const it_free_pro_plus_compare_table_cna = /** @type {(inputs: Free_Pro_Plus_Compare_Table_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`|  | Gratis | Pro | Plus |
| --- | --- | --- | --- |
| Timer di concentrazione | ✔️ | ✔️ | ✔️ |
| Statistiche sulla durata | ✔️ | ✔️ | ✔️ |
| Pianta in gruppo | ✔️ | ✔️ | ✔️ |
| Modalità Concentrazione Intensiva | ✔️ | ✔️ | ✔️ |
| Lista App Consentite personalizzata | - | ✔️ | ✔️ |
| Rimuovi annunci | - | ✔️ | ✔️ |
| Analisi del trend di concentrazione | - | ✔️ | ✔️ |
| Pianta alberi veri* | - | ✔️ | ✔️ |
| Tag personalizzati | - | ✔️ | ✔️ |
| Avvio automatico della sessione successiva | - | ✔️ | ✔️ |
| 3x monete di concentrazione | - | - | ✔️ |
| Goditi gli alberi esclusivi Plus | - | - | ✔️ |
| Prova prima gli Nuovi alberi stagionali | - | - | ✔️ |
| Goditi la Selezione stagionale degli alberi di cristalli | - | - | ✔️ |
| [Time Guard] Blocca più app interruttive | - | - | ✔️ |
| [Spazio Mindful] Goditi vari Soundscape | - | - | ✔️ |

* *Il limite massimo di alberi veri piantabili è 5.`)
};

const ja_free_pro_plus_compare_table_cna = /** @type {(inputs: Free_Pro_Plus_Compare_Table_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`|  | 無料 | Pro | Plus |
| --- | --- | --- | --- |
| フォーカスタイマー | ✔️ | ✔️ | ✔️ |
| 期間統計 | ✔️ | ✔️ | ✔️ |
| 一緒に植える | ✔️ | ✔️ | ✔️ |
| ディープフォーカスモード | ✔️ | ✔️ | ✔️ |
| アプリの許可リストのカスタマイズ | - | ✔️ | ✔️ |
| 広告の削除 | - | ✔️ | ✔️ |
| 集中傾向の分析 | - | ✔️ | ✔️ |
| 本物の木を植える* | - | ✔️ | ✔️ |
| フォーカスタグのカスタマイズ | - | ✔️ | ✔️ |
| 次のセッションを自動開始 | - | ✔️ | ✔️ |
| 獲得コイン3倍 | - | - | ✔️ |
| Plus限定の木を楽しもう | - | - | ✔️ |
| シーズン限定の新しい木を先行お試し | - | - | ✔️ |
| シーズン限定クリスタルツリーを楽しむ | - | - | ✔️ |
| [タイムガード] 邪魔なアプリをさらにブロック | - | - | ✔️ |
| [森のリトリート] さまざまなサウンドスケープ | - | - | ✔️ |

* *植えられる本物の木は最大5本です。`)
};

const ko_free_pro_plus_compare_table_cna = /** @type {(inputs: Free_Pro_Plus_Compare_Table_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`|  | 무료 | Pro | Plus |
| --- | --- | --- | --- |
| 집중 타이머 | ✔️ | ✔️ | ✔️ |
| 기간 통계 | ✔️ | ✔️ | ✔️ |
| 함께 심기 | ✔️ | ✔️ | ✔️ |
| 딥 포커스 모드 | ✔️ | ✔️ | ✔️ |
| 커스텀 앱 앱 허용 리스트 | - | ✔️ | ✔️ |
| 광고 제거 | - | ✔️ | ✔️ |
| 집중 추세 분석 | - | ✔️ | ✔️ |
| 실제 나무 기부하기* | - | ✔️ | ✔️ |
| 사용자 지정 포커스 태그 | - | ✔️ | ✔️ |
| 다음 세션 자동 시작 | - | ✔️ | ✔️ |
| 포커스 코인 3배 획득 | - | - | ✔️ |
| Plus 전용 나무를 즐겨보세요 | - | - | ✔️ |
| 누구보다 먼저 시즌별 신규 나무를 만나세요 | - | - | ✔️ |
| 시즌별 엄선된 크리스탈 나무를 만나보세요 | - | - | ✔️ |
| [타임 가드] 방해되는 앱 차단 한도 증가 | - | - | ✔️ |
| [마음챙김 공간] 다양한 사운드스케이프 지원 | - | - | ✔️ |

* *심을 수 있는 실제 나무는 최대 5그루입니다.`)
};

const pt_br_free_pro_plus_compare_table_cna = /** @type {(inputs: Free_Pro_Plus_Compare_Table_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`|  | Free | Pro | Plus |
| --- | --- | --- | --- |
| Temporizador de foco | ✔️ | ✔️ | ✔️ |
| Estatísticas de duração | ✔️ | ✔️ | ✔️ |
| Plantar juntos | ✔️ | ✔️ | ✔️ |
| Modo Foco Total | ✔️ | ✔️ | ✔️ |
| Lista de permissões personalizada | - | ✔️ | ✔️ |
| Remoção de anúncios | - | ✔️ | ✔️ |
| Análise das tendências de foco | - | ✔️ | ✔️ |
| Plante árvores reais* | - | ✔️ | ✔️ |
| Tags de foco personalizadas | - | ✔️ | ✔️ |
| Início automático da próxima sessão | - | ✔️ | ✔️ |
| 3x mais moedas | - | - | ✔️ |
| Aproveite Árvores exclusivas Plus | - | - | ✔️ |
| Experimente as Novas árvores sazonais primeiro | - | - | ✔️ |
| Aproveite as Árvores sazonais de Cristais do Tempo | - | - | ✔️ |
| [Vigia do Tempo] Bloqueie os aplicativos que mais te interrompem | - | - | ✔️ |
| [Espaço Consciente] Aproveite várias paisagens sonoras | - | - | ✔️ |

* *O limite máximo para plantar árvores reais é 5.`)
};

const ru_free_pro_plus_compare_table_cna = /** @type {(inputs: Free_Pro_Plus_Compare_Table_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`|  | Бесплатно | Pro | Plus |
| --- | --- | --- | --- |
| Таймер фокусировки | ✔️ | ✔️ | ✔️ |
| Статистика продолжительности | ✔️ | ✔️ | ✔️ |
| Сажать вместе | ✔️ | ✔️ | ✔️ |
| Режим глубокой фокусировки | ✔️ | ✔️ | ✔️ |
| Настраиваемый Список разрешений приложений | - | ✔️ | ✔️ |
| Удаление рекламы | - | ✔️ | ✔️ |
| Анализ тенденций фокусировки | - | ✔️ | ✔️ |
| Сажайте настоящие деревья* | - | ✔️ | ✔️ |
| Пользовательские теги фокуса | - | ✔️ | ✔️ |
| Автозапуск следующей сессии | - | ✔️ | ✔️ |
| в 3 раза больше монет за фокусировку | - | - | ✔️ |
| Наслаждайтесь эксклюзивными деревьями Plus | - | - | ✔️ |
| Попробуйте Новые сезонные деревья первым | - | - | ✔️ |
| Наслаждайтесь сезонными кристальными деревьями на выбор | - | - | ✔️ |
| [Контроль времени] Блокируйте больше отвлекающих приложений | - | - | ✔️ |
| [Пространство осознанности] Наслаждайтесь различными звуковыми ландшафтами | - | - | ✔️ |

* *Максимум можно посадить 5 настоящих деревьев.`)
};

const th_free_pro_plus_compare_table_cna = /** @type {(inputs: Free_Pro_Plus_Compare_Table_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`|  | ฟรี | โปร | Plus |
| --- | --- | --- | --- |
| ตัวจับเวลาการโฟกัส | ✔️ | ✔️ | ✔️ |
| สถิติระยะเวลา | ✔️ | ✔️ | ✔️ |
| ปลูกต้นไม้ด้วยกัน | ✔️ | ✔️ | ✔️ |
| โหมดโฟกัสเต็มที่ | ✔️ | ✔️ | ✔️ |
| รายการอนุญาตแอปที่กำหนดเอง | - | ✔️ | ✔️ |
| ลบโฆษณา | - | ✔️ | ✔️ |
| การวิเคราะห์เทรนด์การโฟกัส | - | ✔️ | ✔️ |
| ปลูกต้นไม้จริง* | - | ✔️ | ✔️ |
| แท็กการโฟกัสที่กำหนดเอง | - | ✔️ | ✔️ |
| เริ่มเซสชันถัดไปอัตโนมัติ | - | ✔️ | ✔️ |
| เหรียญการโฟกัส 3 เท่า | - | - | ✔️ |
| เพลิดเพลินกับต้นไม้สุดพิเศษสำหรับ Plus | - | - | ✔️ |
| ลองปลูกต้นไม้ใหม่ประจำฤดูกาลก่อนใคร | - | - | ✔️ |
| เพลิดเพลินกับต้นไม้คริสตัลที่คัดสรรตามฤดูกาล | - | - | ✔️ |
| [การปกป้องเวลา] บล็อกแอปที่รบกวนได้มากขึ้น | - | - | ✔️ |
| [พื้นที่ฝึกสติ] เพลิดเพลินกับทัศนียภาพแห่งเสียงที่หลากหลาย | - | - | ✔️ |

* *ขีดจำกัดสูงสุดในการปลูกต้นไม้จริงคือ 5 ต้น`)
};

const tr_free_pro_plus_compare_table_cna = /** @type {(inputs: Free_Pro_Plus_Compare_Table_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`|  | Ücretsiz | Pro | Plus |
| --- | --- | --- | --- |
| Odak Zamanlayıcısı | ✔️ | ✔️ | ✔️ |
| Süre İstatistikleri | ✔️ | ✔️ | ✔️ |
| Birlikte ağaç dikin | ✔️ | ✔️ | ✔️ |
| Derin Odak Modu | ✔️ | ✔️ | ✔️ |
| Özel Uygulama İzin Listesi | - | ✔️ | ✔️ |
| Reklamları Kaldır | - | ✔️ | ✔️ |
| Odaklanma trend analizi | - | ✔️ | ✔️ |
| Gerçek ağaçlar dik* | - | ✔️ | ✔️ |
| Özel Odak Etiketleri | - | ✔️ | ✔️ |
| Sonraki Oturumu Otomatik Başlat | - | ✔️ | ✔️ |
| 3x odaklanma jetonu | - | - | ✔️ |
| Plus’a Özel Ağaçların keyfini çıkarın | - | - | ✔️ |
| Önce Mevsimsel Yeni Ağaçlarını dene | - | - | ✔️ |
| Mevsimsel Seçkin Kristal Ağaçlarnın keyfini çıkar | - | - | ✔️ |
| [Zaman Koruması] Daha fazla rahatsız edici uygulamayı engelle | - | - | ✔️ |
| [Farkındalık Alanı] Çeşitli ses manzaralarının tadını çıkar | - | - | ✔️ |

* *Gerçek ağaç dikmenin azami limiti 5’tir.`)
};

const zh_cn_free_pro_plus_compare_table_cna = /** @type {(inputs: Free_Pro_Plus_Compare_Table_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`|  | 免费版 | 专业版 | Plus 会员 |
| --- | --- | --- | --- |
| 专注计时 | ✔️ | ✔️ | ✔️ |
| 时长统计 | ✔️ | ✔️ | ✔️ |
| 与好友一起种 | ✔️ | ✔️ | ✔️ |
| 深度专注 | ✔️ | ✔️ | ✔️ |
| 自订软件白名单 | - | ✔️ | ✔️ |
| 无广告 | - | ✔️ | ✔️ |
| 专注趋势分析 | - | ✔️ | ✔️ |
| 为地球种下真树* | - | ✔️ | ✔️ |
| 自订专注标签 | - | ✔️ | ✔️ |
| 自动下一轮专注 | - | ✔️ | ✔️ |
| 专注金币 3 倍 | - | - | ✔️ |
| 独享 Plus 限定树种 | - | - | ✔️ |
| 抢先体验每季最新树种 | - | - | ✔️ |
| 无限使用当季精选宝石树 | - | - | ✔️ |
| [时间守护] 阻挡多个干扰 App | - | - | ✔️ |
| [正念空间] 享受更多声音场景 | - | - | ✔️ |

* *种真树目前上限为 5 棵。`)
};

const zh_tw_free_pro_plus_compare_table_cna = /** @type {(inputs: Free_Pro_Plus_Compare_Table_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`|  | 免費版 | 專業版 | 訂閱 Plus |
| --- | --- | --- | --- |
| 專注計時 | ✔️ | ✔️ | ✔️ |
| 時長統計 | ✔️ | ✔️ | ✔️ |
| 一起種 | ✔️ | ✔️ | ✔️ |
| 深度專注 | ✔️ | ✔️ | ✔️ |
| 自訂 App 允許名單 | - | ✔️ | ✔️ |
| 無廣告 | - | ✔️ | ✔️ |
| 專注趨勢分析 | - | ✔️ | ✔️ |
| 為地球種下真樹* | - | ✔️ | ✔️ |
| 自訂專注標籤 | - | ✔️ | ✔️ |
| 自動下一輪專注 | - | ✔️ | ✔️ |
| 專注金幣 3 倍 | - | - | ✔️ |
| 獨享 Plus 限定樹種 | - | - | ✔️ |
| 搶先體驗每季最新樹種 | - | - | ✔️ |
| 無限使用當季精選寶石樹 | - | - | ✔️ |
| [時間守護] 阻擋多個干擾 App | - | - | ✔️ |
| [正念空間] 享受更多聲音場景 | - | - | ✔️ |

* *種真樹目前上限為 5 棵。`)
};

/**
* | output |
* | --- |
* | "\| \| Free \| Pro \| Plus \| \| --- \| --- \| --- \| --- \| \| Focus Timer \| ✔️ \| ✔️ \| ✔️ \| \| Duration Statistics \| ✔️ \| ✔️ \| ✔️ \| \| Plant together \| ✔️ \| ✔️ \| ✔️ \| \| D..." |
*
* @param {Free_Pro_Plus_Compare_Table_CnaInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const free_pro_plus_compare_table_cna = /** @type {((inputs?: Free_Pro_Plus_Compare_Table_CnaInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Free_Pro_Plus_Compare_Table_CnaInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_free_pro_plus_compare_table_cna(inputs)
	if (locale === "ar") return ar_free_pro_plus_compare_table_cna(inputs)
	if (locale === "de") return de_free_pro_plus_compare_table_cna(inputs)
	if (locale === "es") return es_free_pro_plus_compare_table_cna(inputs)
	if (locale === "fr") return fr_free_pro_plus_compare_table_cna(inputs)
	if (locale === "it") return it_free_pro_plus_compare_table_cna(inputs)
	if (locale === "ja") return ja_free_pro_plus_compare_table_cna(inputs)
	if (locale === "ko") return ko_free_pro_plus_compare_table_cna(inputs)
	if (locale === "pt_br") return pt_br_free_pro_plus_compare_table_cna(inputs)
	if (locale === "ru") return ru_free_pro_plus_compare_table_cna(inputs)
	if (locale === "th") return th_free_pro_plus_compare_table_cna(inputs)
	if (locale === "tr") return tr_free_pro_plus_compare_table_cna(inputs)
	if (locale === "zh_cn") return zh_cn_free_pro_plus_compare_table_cna(inputs)
	return zh_tw_free_pro_plus_compare_table_cna(inputs)
});